import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../modules/layout/components/ToastContext';
import { useNavigate } from 'react-router-dom';
import { update } from '../_request';

interface ActivateProfileProps {
    targetProfileId: string;
    onSuccess: () => void;
}

export default function ActivateProfile({targetProfileId, onSuccess}: ActivateProfileProps) {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [ open, setOpen ] = useState(false);

    const handleActivate = async() => {
        try {
            setLoading(true);
            const result: any = await update(`/api/UserEvents/activateprofile?targetProfileId=${encodeURIComponent(targetProfileId)}`, null);           
            const respStatus = result?.status ?? result?.response?.status;     

            if (respStatus === 200 || respStatus === 204 || respStatus === undefined) {
                showToast && showToast(t('ProfileActivatedSuccessfully'), 'success');
                onSuccess();
            } else if (respStatus === 401) {
                navigate('/auth/login');
            } else if (respStatus === 403) {
                navigate('/error/403');
            } else if (respStatus === 404) {
                showToast && showToast(t('ProfileNotFound'), 'error');
            } else if (respStatus === 500) {
                navigate('/error/500');
            } else {
                showToast &&
                showToast(t('StatusCode', { code: String(respStatus) }), 'error');
            }
        } catch (err: any){
            console.error(err);
            showToast && showToast(t('ConnectionError', { error: String(err) }), 'error');
        } finally {
        setLoading(false);
        setOpen(false);
      }
    }

    return(
        <>
            <button className="btn gg-btn gg-btn-profile--primary me-2" onClick={() => setOpen(true)} >
                    {t('ActivateProfile')}
            </button>

            {open && (
                <div className="gg-modal-overlay">
                    <div className="gg-modal">
                        <div className="gg-modal-header">
                            <h5 className="mb-0">
                                {t('ActivateProfile')}
                            </h5>                                   
                        </div>

                        <div className="gg-modal-body">
                            <p className="text-muted small mb-0">
                                {t('ActivatingRestores')}
                            </p>
                        </div>

                        <div className="gg-modal-footer">
                            <button
                                className="gg-btn"
                                onClick={() => setOpen(false)}
                                disabled={loading}
                            >
                                {t('Cancel')}
                            </button>

                            <button
                                className="btn btn-secondary text-white"
                                onClick={handleActivate}
                                disabled={loading}
                            >
                                {loading ? t('Activating'): t('Confirm')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>   
    );
};